<form class="xr-auth-stack" [formGroup]="verifyOtpForm" (ngSubmit)="onSubmit()">
  <div>
    <h1 class="xr-auth-title">{{ "otp.title" | translate }}</h1>
    <p class="xr-auth-subtitle">
      @if (email) {
        {{ "otp.sent_to" | translate }} <strong>{{ email | maskEmail }}</strong>.
      } @else {
        {{ "otp.sent_to_your_email" | translate }}
      }
      {{ "otp.valid_for" | translate }}
    </p>
  </div>

  <fieldset class="xr-otp-fieldset">
    <legend class="xr-auth-label">{{ "otp.code_label" | translate }}</legend>
    <div class="xr-otp-grid" formArrayName="otp">
      <input
        *ngFor="let control of otpControls; let i = index"
        type="text"
        inputmode="numeric"
        [attr.autocomplete]="i === 0 ? 'one-time-code' : 'off'"
        [formControlName]="i"
        minlength="1"
        maxlength="1"
        class="xr-otp-input"
        [attr.aria-label]="'otp.digit_label' | translate: { n: i + 1 }"
        (input)="onInputChange(i, $event)"
        (keydown)="onKeyDown(i, $event)"
        #otpInput
      />
    </div>
    <p class="xr-auth-error" role="alert" *ngIf="verifyOtpForm.controls['otp'].invalid && verifyOtpForm.touched">
      {{ 'otp.all_codes_required' | translate }}
    </p>
  </fieldset>

  <button type="submit" class="xr-btn xr-btn--primary xr-auth-submit" [disabled]="verifyOtpForm.invalid">
    {{ "otp.verify_and_enter" | translate }}
  </button>

  <p class="xr-auth-note">
    {{ "otp.not_code" | translate }}
    <button type="button" class="xr-auth-link" (click)="resendOtp()">{{ "otp.resend" | translate }}</button>
    <span aria-hidden="true">·</span>
    <a [routerLink]="['/login']" class="xr-auth-link">{{ "otp.change_email" | translate }}</a>
  </p>
</form>
